module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chatwoot_bot-905112376e6493b37e2cecea8f9dc50c.png";